import React, { useEffect, useCallback } from 'react';
import { Tab } from 'semantic-ui-react';
import OpenTickets from './Components/OpenTickets';
import ClosedTickets from './Components/ClosedTickets';
import { EN, ES } from './Etiquetas/Labels';
import { FormEnglish, FormEsp } from './Form';
import './theme/theme.scss';
import CreateNewTicket from './app/CreateTicket';
import Axios from 'axios';
import { Services } from './Services'
import ContentWrapper from './Components/ContenWraper/ContentWrapper'
import { DefaultLoader } from './config/defaultLoader';
import './style.css'


const TabConfig = ({
  projectId,
  labels,
  ticketsOpen,
  ticketsClosed,
  language,
  styleProject
}) => {
  // Configuración base común para todos los proyectos
  const basePanes = [
    {
      menuItem: `${labels.open_tickets.title} (${ticketsOpen.length})`,
      render: () => (
        <OpenTickets
          tickets={ticketsOpen}
          language={language}
          idProject={projectId}
          styleProject={styleProject}
        />
      )
    },
    {
      menuItem: `${labels.closed_tickets.title} (${ticketsClosed.length})`,
      render: () => (
        <ClosedTickets
          tickets={ticketsClosed}
          language={language}
          idProject={projectId}
          styleProject={styleProject}
        />
      )
    }
  ];

  const project6MenuConfig = {
    secondary: true,
    pointing: true,
    className: "custom-tab-menu"
  };

  const tabProps = {
    panes: basePanes,
    ...(projectId === 6 && { menu: project6MenuConfig })
  };

  return <Tab {...tabProps} />;
};


function HelpDesk(props) {
  const { CustomLoader = DefaultLoader } = props;

  const [Labels, setLabels] = React.useState(EN);
  const [Form, setForm] = React.useState(FormEnglish);
  const [ticketsOpen, setTicketsOpen] = React.useState([]);
  const [ticketsClosed, setTicketsClosed] = React.useState([]);
  const [ActiveLoader, setActiveLoader] = React.useState(false)
  const [language, setLanguaje] = React.useState(undefined)
  const [tz] = React.useState(Intl.DateTimeFormat().resolvedOptions().timeZone)


  const GetTikets = useCallback(async (id) => {
    let body = { id: id, _rolId: props._rolId, _user: props._user, timezone: tz }
    try {
      let Tikets = await Axios.post(`${Services.TICKETS.path}Ticket/getTicketsUser`, body);
      setTicketsOpen(Tikets.data.data.Open);
      setTicketsClosed(Tikets.data.data.Closed)
      setActiveLoader(true)
    } catch (error) {
      console.log('The Error-->', error);
    }
  }, []);

  useEffect(() => {
    GetTikets(props.ProjectId);
    setLanguaje(props.lng === 'EN' ? 'Ingles' : 'Español')
    setLabels(props.lng === 'EN' ? EN : ES)
    setForm(props.lng === 'EN' ? FormEnglish : FormEsp)
  }, [props]);


  return (
    <ContentWrapper>
      <CustomLoader hidden={ActiveLoader} />

      {/* Header personalizable */}
      {props.customHeader ? (
        props.customHeader
      ) : (
        <div className="content-heading">
          <div className={props.style?.titleModule || ''}>
            <i className={Labels.header.icon} />
            <b>{Labels.header.title}</b>
          </div>
        </div>
      )}


      <div>
        <CreateNewTicket
          GetTikets={GetTikets}
          PropsProject={props}
          labels={Labels}
          Form={Form}
          language={language}
          loader={CustomLoader}
        />

        <TabConfig
          projectId={props.ProjectId}
          labels={Labels}
          ticketsOpen={ticketsOpen}
          ticketsClosed={ticketsClosed}
          language={language}
          styleProject={props.style}
        />
      </div>
    </ContentWrapper>
  );
}
export default HelpDesk;